import React from "react";
import "./footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footerContainer">
        {/* Crédits */}
        <div className="footerLeft">
          <p className="copyright">© Luka.B Folio {currentYear}</p>
          <p className="designer">
            Designed and developed with LUV by Luka Brouard. 💫​
          </p>
        </div>

        {/* Liens en colonnes */}
        <div className="footerRight">
          <div className="footerColumn">
            <a
              href="https://www.linkedin.com/in/luka-brouard-026584289/"
              target="_blank"
              rel="noreferrer"
            >
              Linkedin
            </a>
            <a
              href="https://github.com/JustKIKS"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a>
          </div>
          <div className="footerColumn">
            <a
              href="/assets/CV/CV_LUKA_BROUARD_.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Resume
            </a>
            <a href="mailto:brouar_l@etna-alternance.net">Let's talk ?</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
